import { StarFilled } from '@ant-design/icons';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export interface SuggestionCardProps {
  children: React.ReactNode;
}

export function SuggestionCard(props: SuggestionCardProps) {
  const { t } = useTranslation('common');

  return (
    <div className="flex flex-col gap-1 p-[2px] bg-primary-600 rounded-xl">
      <div className="flex gap-2 px-2 py-1">
        <div className="text-green-500">
          <StarFilled />
        </div>
        <span className="text-white font-semibold">{t('ai_suggestion')}</span>
      </div>
      <div className="bg-white p-2 rounded-[10px]">{props.children}</div>
    </div>
  );
}

export default SuggestionCard;
